const ufeApi = require('services/api/ufeApi');
const URL = '/api/secure/validatePasswordToken';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Validate+Password+Token+API

function validatePasswordToken (securityToken) {
    return ufeApi.makeRequest(URL, {
        method: 'POST',
        body: JSON.stringify({ securityToken })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = validatePasswordToken;
